import React, {useRef, useCallback} from 'react';
import {WIDTH, LEFT_SPACE} from '../pianoroll/constants.js';

export const useStepNumber = ({
    parentClassName,
    xScale,
    leftSpace=LEFT_SPACE
}) => {
    let parentElement = useRef(undefined);

    const getScrollLeft = useCallback(() => {
        if (parentClassName) {
            let el = parentElement.current || document
                .getElementsByClassName(parentClassName)[0];
            if (parentElement.current === undefined) {
                parentElement.current = el;
            }
            return el.scrollLeft;
        }
        return 0;
    }, [parentClassName]);

    const getOffset = useCallback((e) => {
        return getScrollLeft() + e.pageX - getLeft(e) - leftSpace;
    }, [xScale, parentClassName, leftSpace]);

    const getLeft = useCallback((e) => {
        return getStepNumber(e) * WIDTH * xScale;
    }, [xScale]);

    const getStepNumber = useCallback((e) => {
        return (getScrollLeft() + e.pageX - leftSpace) / (WIDTH * xScale);
    }, [xScale, leftSpace]);

    return {getStepNumber, getScrollLeft, getLeft, getOffset};
};
